import { useTextTranslation } from "../../utils/useTextTranslation";
import { watchProgress } from "../../utils/watchProgress";
import { toTrackId } from "../../analytics/trackIds";
import { openVodDetail } from "../newVodDetail/vodModalNavigation";
import CinemaIcon from "../cinema/CinemaIcon";
import RankNumber from "../carousel/RankNumber";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import localizationStrings from "../../statics/localization";
import defaultPoster from "../../assets/images/no-portrait-poster.png";
import defaultHorizontalPoster from "../../assets/images/default-vod-horizontal-poster.png";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import useOutsideClick from "../../utils/useOutsideClick";
import { getPosterUrlByType } from "../../utils/findPoster";

const VodItem = ({
  item,
  itemsToShow,
  useSubType,
  showProgress,
  isFavList,
  isVertical,
  fromSearch,
  removeFromFav,
  removeFromKeepWatch,
  onHoverItem,
  useContentType,
  index,
  label,
  rank,
  slidesToScroll,
  isCatchup = false
}) => {
  const translateText = useTextTranslation();
  const copy = getCinemaCopy();
  const [posterUrl, setPosterUrl] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const progress = watchProgress(item);
  const history = useHistory();
  const optionRef = useRef(null);
  const itemRef = useRef(null);
  const timeoutRef = useRef(null);

  useOutsideClick(optionRef, () => {
    setShowOptions(false);
  }, showOptions);

  const cardTrackId = (...parts) => label?.id ? toTrackId("card", label.id, index + 1, ...parts) : undefined;

  const onClickVod = () => {
    if (item?.type === "CHANNEL") {
      history.push(`/dashboard/livetv/${item.channelId || item.id}`);
    } else if (item?.type === "CATEGORY") {
      history.push(`/dashboard/home/${item.id}/all`);
    } else if (isCatchup) {
      history.push(`/dashboard/catchupdetail/${item?.id}`);
    } else {
      openVodDetail(history, item?.id);
    }
  };

  useEffect(() => {
    if (item) {
      setPosterUrl(
        isVertical
          ? getPosterUrlByType(item?.posters, "Web Portrait")
          : getPosterUrlByType(item?.posters, "Web Landscape")
      );

    }
  }, [item, isVertical, showProgress]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <div
      ref={itemRef}
      className={`vod-item cinema-card ${
        isVertical ? "cinema-card-portrait" : "cinema-card-landscape"
      }${rank ? " cinema-card-ranked" : ""}`}
      style={{
        position: "relative",
        width: itemsToShow ? `${100 / itemsToShow}%` : ""
      }}
      onMouseEnter={() => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        if (
          !onHoverItem || ["CHANNEL", "CATEGORY"].includes(item?.type) ||
          !window.matchMedia("(hover: hover) and (min-width: 1000px)").matches
        )
          return;
        timeoutRef.current = setTimeout(() => {
          if (itemRef.current?.closest(".cinema-scroll-track")?.dataset.scrolling === "true") return;
          let pos = itemRef.current?.getClientRects();
          if (pos?.length) {
            pos = pos[0];
          }
          let _data = {
            position: pos,
            anchorElement: itemRef.current,
            scrollX: window.scrollX,
            scrollY: window.scrollY,
            posterPosition: 6,
            vod: item
          };

          onHoverItem(true, _data, index === 0, index % slidesToScroll === 0);
        }, 500);
      }}
      onMouseLeave={() => {
        clearTimeout(timeoutRef.current);
      }}
    >
      {rank && <RankNumber rank={rank} />}
      <div
        key={item?.id}
        data-track-id={cardTrackId()}
        className="carousel-item"
        role="link"
        tabIndex={0}
        aria-label={translateText(rank ? `${rank}. ${translateText(item?.title)}` : translateText(item?.title))}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            clearTimeout(timeoutRef.current);
            onClickVod();
          }
        }}
        style={{
          ...(itemsToShow ? { display: "flex" } : {}),
          ...(showProgress ? { borderRadius: "0.417vw 0.417vw 0 0" } : {})
        }}
        onClick={(e) => {
          e.currentTarget.focus({ preventScroll: true });
          onClickVod();
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          if (onHoverItem) onHoverItem(false);
        }}
      >
        <img
          alt={translateText(item?.title)}
          className="carousel-poster"
          loading="lazy"
          decoding="async"
          src={posterUrl}
          onError={() =>
            setPosterUrl(isVertical ? defaultPoster : defaultHorizontalPoster)
          }
        />

        <span className="cinema-card-play" aria-hidden="true">
          <CinemaIcon name="play" />
        </span>
        {isFavList || showProgress ? (
          <div
            ref={optionRef}
            data-track-id={cardTrackId("options")}
            className="dot-options"
            onClick={(e) => {
              e.stopPropagation();
              setShowOptions(!showOptions);
            }}
          >
            <div className="dots-wrapper">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className={`options-box ${showOptions ? "show" : ""}`}>
                <div className="tri-angle"></div>
                <div className="options">
                  <div
                    data-track-id={cardTrackId("remove")}
                    className="option"
                    onClick={() => {
                      isFavList
                        ? removeFromFav(item, false)
                        : removeFromKeepWatch(item);
                    }}
                  >
                    <TrashIcon />
                    <span>
                      {isFavList
                        ? localizationStrings.removeFromMyList
                        : localizationStrings.removeFromContinueWatching}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {showProgress ? (
        <div
          className="bookmark-progress"
          role="progressbar"
          aria-label={copy.continue}
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>
      ) : null}
      <div className="cinema-card-caption">
        <span className="cinema-card-title" dir="auto">{translateText(item?.title)}</span>
        <span className="cinema-card-meta">
          {item?.type === "SERIES"
            ? copy.series
            : item?.type === "MOVIE"
            ? copy.movie
            : item?.type === "PROGRAM"
            ? copy.program
            : ""}
          {item?.year ? ` · ${item.year}` : ""}
        </span>
      </div>
    </div>
  );
};

export default VodItem;
